"use client";

import { c as _c } from "react/compiler-runtime";
import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { useApproveTaskMutation, useLocalTaskUpdateMutation } from "@/src/lib/data-fetchers/tasks-fetchers";
import { type Task, TaskStatus } from "@/src/models/task";
export function TprCoverageContinueButton(t0) {
  const $ = _c(10);
  const {
    task
  } = t0;
  const approvalMutation = useApproveTaskMutation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      invalidateOnSettled: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const localTaskUpdateMutation = useLocalTaskUpdateMutation(t1);
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  let t2;
  if ($[1] !== approvalMutation || $[2] !== invalidateInstructions || $[3] !== localTaskUpdateMutation || $[4] !== task) {
    t2 = async () => {
      ;
      try {
        await approvalMutation.mutateAsync({
          taskId: task.id,
          approved: true
        });
        localTaskUpdateMutation.mutate({
          ...task,
          status: TaskStatus.PROCESSING
        });
        refreshTprWorkflowProgress(invalidateInstructions);
        toast({
          title: "Coverage confirmed",
          description: "The workflow is continuing with Athena eligibility and authorization checks."
        });
      } catch (t3) {
        const error = t3;
        toast({
          title: "Coverage is not ready",
          description: error instanceof Error ? error.message : "Correct the Athena coverage and try again.",
          variant: "destructive"
        });
      }
    };
    $[1] = approvalMutation;
    $[2] = invalidateInstructions;
    $[3] = localTaskUpdateMutation;
    $[4] = task;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleContinue = t2;
  const t3 = approvalMutation.isPending || localTaskUpdateMutation.isPending;
  const t4 = approvalMutation.isPending ? "Checking Athena..." : "Continue";
  let t5;
  if ($[6] !== handleContinue || $[7] !== t3 || $[8] !== t4) {
    t5 = <Button onClick={handleContinue} disabled={t3}>{t4}</Button>;
    $[6] = handleContinue;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}